import React, { useEffect, useMemo, useState } from 'react';
import BussinessApi from '@/fetch/bussiness';
import './index.scss';
import { RemoteCommandType } from '@/utils/constant';
import { debounce } from '@/utils/util';
const requestApi = new BussinessApi();
const Lights = (props: {
  headLight: boolean;
  warningFlash: boolean;
  turnLeft: boolean;
  turnRight: boolean;
  vehicleName: string;
  cockpitNumber: string;
  userName: string;
  LC_BUTTON_UP: boolean;
  LC_BUTTON_DOWN: boolean;
  LC_BUTTON_LEFT: boolean;
  LC_BUTTON_RIGHT: boolean;
}) => {
  const {
    headLight,
    warningFlash,
    turnLeft,
    turnRight,
    vehicleName,
    cockpitNumber,
    userName,
    LC_BUTTON_UP,
    LC_BUTTON_DOWN,
    LC_BUTTON_LEFT,
    LC_BUTTON_RIGHT,
  } = props;
  const [lightsControl, setLightsControl] = useState<any>({
    left: false,
    warning: false,
    right: false,
    highLight: false,
  });

  const btnList = useMemo(
    () => [
      {
        type: 'warning',
        ico: require('@/assets/images/monitor/warning.png'),
        isActive: warningFlash,
        activeIco: require('@/assets/images/monitor/active-warning.png'),
      },
      {
        type: 'left',
        ico: require('@/assets/images/monitor/left.png'),
        isActive: turnLeft,
        activeIco: require('@/assets/images/monitor/active-left.png'),
      },
      {
        type: 'right',
        ico: require('@/assets/images/monitor/right.png'),
        isActive: turnRight,
        activeIco: require('@/assets/images/monitor/active-right.png'),
      },
      {
        type: 'highLight',
        ico: require('@/assets/images/monitor/highlight.png'),
        isActive: headLight,
        activeIco: require('@/assets/images/monitor/active-highlight.png'),
      },
    ],
    [warningFlash, turnLeft, turnRight, headLight]
  );

  const sendRemoteCommand = (commandType: RemoteCommandType) => {
    requestApi.buttonCommand({
      cockpitNumber: cockpitNumber,
      vehicleName: vehicleName,
      cockpitUserName: userName,
      remoteCommandType: commandType,
    });
  };
  // 开关大灯
  useEffect(() => {
    if (lightsControl.highLight == false && LC_BUTTON_UP == true) {
      debounce(() => {
        sendRemoteCommand(RemoteCommandType.HEAD_LIGHT_ON);
        setLightsControl({
          ...lightsControl,
          highLight: true,
        });
      }, 500)();
    } else if (lightsControl.highLight == true && LC_BUTTON_UP == true) {
      debounce(() => {
        sendRemoteCommand(RemoteCommandType.HEAD_LIGHT_OFF);
        setLightsControl({
          ...lightsControl,
          highLight: false,
        });
      }, 500)();
    }
  }, [LC_BUTTON_UP, lightsControl.highLight]);

  // 开关双闪
  useEffect(() => {
    if (lightsControl.warning == false && LC_BUTTON_DOWN == true) {
      debounce(() => {
        sendRemoteCommand(RemoteCommandType.HAZARD_LIGHT_BOTH);
        setLightsControl({
          ...lightsControl,
          warning: true,
        });
      }, 500)();
    } else if (lightsControl.warning == true && LC_BUTTON_DOWN == true) {
      debounce(() => {
        sendRemoteCommand(RemoteCommandType.HAZARD_LIGHT_OFF);
        setLightsControl({
          ...lightsControl,
          warning: false,
        });
      }, 500)();
    }
  }, [LC_BUTTON_DOWN, lightsControl.warning]);

  // 开关左转灯
  useEffect(() => {
    if (lightsControl.left == false && LC_BUTTON_LEFT == true) {
      debounce(() => {
        sendRemoteCommand(RemoteCommandType.HAZARD_LIGHT_LEFT);
        setLightsControl({
          ...lightsControl,
          left: true,
        });
      }, 500)();
    } else if (lightsControl.left == true && LC_BUTTON_LEFT == true) {
      debounce(() => {
        sendRemoteCommand(RemoteCommandType.HAZARD_LIGHT_OFF);
        setLightsControl({
          ...lightsControl,
          left: false,
        });
      }, 500)();
    }
  }, [LC_BUTTON_LEFT, lightsControl.left]);

  // 开关右转灯
  useEffect(() => {
    if (lightsControl.right == false && LC_BUTTON_RIGHT == true) {
      debounce(() => {
        sendRemoteCommand(RemoteCommandType.HAZARD_LIGHT_RIGHT);
        setLightsControl({
          ...lightsControl,
          right: true,
        });
      }, 500)();
    } else if (lightsControl.right == true && LC_BUTTON_RIGHT == true) {
      debounce(() => {
        sendRemoteCommand(RemoteCommandType.HAZARD_LIGHT_OFF);
        setLightsControl({
          ...lightsControl,
          right: false,
        });
      }, 500)();
    }
  }, [LC_BUTTON_RIGHT, lightsControl.right]);

  return (
    <div className="btn-list">
      {btnList.map((i, index) => (
        <img
          src={i.isActive ? i.activeIco : i.ico}
          className={i.type}
          key={i.type || index}
        />
      ))}
    </div>
  );
};

export default React.memo(Lights);
